const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const getLocalDateString = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  const validDate = Number.isNaN(date.getTime()) ? new Date() : date;
  const year = validDate.getFullYear();
  const month = String(validDate.getMonth() + 1).padStart(2, "0");
  const day = String(validDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const dateOnlyToLocalIso = (value) => {
  const match = String(value || "").match(DATE_ONLY_PATTERN);
  if (!match) return new Date().toISOString();

  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day)).toISOString();
};

export const getRegistroTimestamp = ({ createdAt, playedAt } = {}) => {
  if (createdAt) {
    const createdDate = new Date(createdAt);
    if (!Number.isNaN(createdDate.getTime())) return createdDate.toISOString();
  }

  return dateOnlyToLocalIso(playedAt);
};
